type InactiveLocation = {
  inactive?: boolean | null;
};

export const isLocationActive = <T extends InactiveLocation>(location: T) => location.inactive !== true;

export const filterActiveLocations = <T extends InactiveLocation>(locations: T[] = []) => {
  return locations.filter(isLocationActive);
};
